// Typelizer digest 357514d7ba00b6de433085da2b2a9766
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /educators/relief/applications */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/educators/relief/applications', {}, options),
    method: 'post',
  }),

  /** GET /educators/relief/applications/new */
  new: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/relief/applications/new', {}, options),
    method: 'get',
  }),

  /** GET /educators/relief/applications/:id/edit */
  edit: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/relief/applications/:id/edit', params, options),
    method: 'get',
  }),

  /** GET /educators/relief/applications/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/relief/applications/:id', params, options),
    method: 'get',
  }),

  /** PATCH /educators/relief/applications/:id */
  update: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/educators/relief/applications/:id', params, options),
    method: 'patch',
  }),
}
